import Storage from '..';

class SessionStorage extends Storage {
  getInterface = (): globalThis.Storage => {
    return sessionStorage;
  };
}

export default new SessionStorage();
